/**
 * Turns an API failure into something a person can act on.
 *
 * The backend's error middleware answers a Mongoose validation failure with a
 * generic `error: "Validation failed"` plus the useful part in `details[]`
 * ("Path `createdBy` is required."). HttpError builds its `message` from
 * `error` alone, so showing `err.message` gives the admin a red banner reading
 * "Validation failed" with no indication of what to fix.
 */
export const describeApiError = (err: unknown, fallback: string): string => {
  const data = (err as any)?.data;

  const details = data?.details;
  if (Array.isArray(details) && details.length > 0) {
    return details.join(' ');
  }
  if (typeof details === 'string' && details.trim()) {
    return details;
  }

  const message = (err as any)?.message;
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  return fallback;
};
